import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import '../styles/PixelHeader.css';
import '../styles/Header.css';
import logoImg from '../assets/YourGardenGuru_Logo.png';

const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const visible = prevScrollPos > currentScrollPos || currentScrollPos < 10;
      setIsVisible(visible);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleNavigation = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0 });
  };

  const scrollToSection = () => {
    const section = document.getElementById('homepage-eventscomm-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleEventsClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname === '/') {
      scrollToSection();
    } else {
      // navigate('/', { state: { scrollTo: 'homepage-eventscomm-section' } });
      navigate('/#homepage-eventscomm-section');
    }
  };

  return (
    <header className={`garden-header ${isVisible ? '' : 'header-hidden'}`}>
      <div className="garden-header-content">

        {/* Logo Area */}
        <div className="garden-logo">
          <NavLink to="/" end onClick={handleNavigation}>
            <img src={logoImg} alt="YourGardenGuru" className="garden-logo-img" />
            <span className="garden-logo-text">Your<span className='greenText'>Garden</span>Guru</span>
          </NavLink>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="burger-icon" onClick={toggleMenu}>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        </div>

        {/* Navigation Links */}
        <nav className={`garden-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li><NavLink to="/" end className="garden-nav-link" onClick={handleNavigation}>Home</NavLink></li>
            <li><NavLink to="/find-plants" className="garden-nav-link" onClick={handleNavigation}>Find Plants</NavLink></li>
            <li><NavLink to="/dashboard" className="garden-nav-link" onClick={handleNavigation}>My Garden</NavLink></li>
            <li><NavLink to="/report" className="garden-nav-link" onClick={handleNavigation}>My Eco Impact</NavLink></li>
            <li><NavLink to="/ai-doctor" className="garden-nav-link special" onClick={handleNavigation}>Plant Doctor</NavLink></li>
            {/* <li><a href="/" className="garden-nav-link" onClick={handleEventsClick}>Events & Communities</a></li> */}
          </ul>
        </nav>

      </div>
    </header>
  );
};

export default Header;
